import { API } from 'utils';
import { RootDispatch } from '../store';
import {
  Statement,
  StatementResponse,
  ConfirmedStatement,
  ConfirmStatementsPayload,
  Consent,
  ConsentResponse,
  UpdateConsentRequest,
  UpdateConsentResponse,
  NewStatementResponse,
  NewConfirmedStatement,
  UpdatedConsent,
  NewConsentResponse
} from './statement.model';
import { mapNewStatementToDeprecated } from './statement.mapper';

const endpointDeprecated = '/statement';
const endpoint = '/statements';

const effects = (dispatch: RootDispatch) => ({
  async getStatementsDeprecated(): Promise<Statement[]> {
    return API.get<undefined, StatementResponse>(
      `${endpointDeprecated}/informationObligation`
    )
      .then((response) => {
        dispatch.statements.storeAllStatements(response.data.statements);
        return response.data.statements;
      })
      .catch((error) => {
        console.error(error);
        return error;
      });
  },
  async getStatements(): Promise<Statement[]> {
    return API.get<undefined, NewStatementResponse>(`${endpoint}/obligations`)
      .then((response) => {
        const mappedValues = mapNewStatementToDeprecated(response.data);
        dispatch.statements.storeAllStatements(mappedValues);
        return mappedValues;
      })
      .catch((error) => {
        console.error(error);
        return error;
      });
  },
  turnOffStatementsDeprecated(payload: ConfirmedStatement[]): any {
    return API.put<ConfirmStatementsPayload, any>(
      `${endpointDeprecated}/informationObligation`,
      {
        confirmedStatements: payload
      }
    )
      .then((response) => {
        dispatch.statements.storeAllStatements([]);
        return response;
      })
      .catch((error) => {
        console.error(error);
        return error;
      });
  },
  turnOffStatements(payload: NewConfirmedStatement[]): any {
    return API.post<NewConfirmedStatement[], any>(
      `${endpoint}/obligations`,
      payload
    )
      .then((response) => {
        dispatch.statements.storeAllStatements([]);
        return response;
      })
      .catch((error) => {
        console.error(error);
        return error;
      });
  },
  async getConsentsDeprecated(): Promise<Consent[]> {
    return API.get<undefined, ConsentResponse>(
      `${endpointDeprecated}/marketingConsent`
    )
      .then((response) => {
        dispatch.statements.storeAllConsents(response.data.consents);
        return response.data.consents;
      })
      .catch((error) => {
        console.error(error);
        return error;
      });
  },
  async getConsents(): Promise<Consent[]> {
    return API.get<undefined, NewConsentResponse>(`${endpoint}/consents`)
      .then((response) => {
        dispatch.statements.storeAllConsents(response.data);
        return response.data;
      })
      .catch((error) => {
        console.error(error);
        return error;
      });
  },
  async updateConsentsDeprecated(data: UpdateConsentRequest): Promise<number> {
    return API.put<UpdateConsentRequest, UpdateConsentResponse>(
      `${endpointDeprecated}/marketingConsent`,
      data
    )
      .then((response) => response.status)
      .catch((error) => {
        console.error(error);
        return error;
      });
  },
  async updateConsents(data: UpdatedConsent[]): Promise<number> {
    return API.post<UpdatedConsent[], UpdateConsentResponse>(
      `${endpoint}/consents`,
      data
    )
      .then((response) => response.status)
      .catch((error) => {
        console.error(error);
        return error;
      });
  }
});

export default effects;
